<template>
  <div class="modal fade" id="AddContratModal" tabindex="-1" role="dialog" ref="addContratModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="Parametre">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Activation du contrat</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="parametreForm" @submit="modifContratEtat" :validation-schema="contratSchema">
            <div class="row">
              <div class="col-md-12" v-show="false">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Contrat <span class="text-danger">*</span>
                  </label>
                  <Field name="contrat" v-model="contrat" type="text" hidden
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la contrat" />
                  <ErrorMessage name="contrat" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4 col-xl-4 col-lg-4 col-sm-12 col-xm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold" for="dateMiseEnService">
                    Date Mise En Service
                  </label>
                  <Field name="dateMiseEnService" type="Date" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libelle" />
                  <ErrorMessage name="dateMiseEnService" class="text-danger" />
                </div>
              </div>

              <div class="col-md-8 col-xl-8 col-lg-8 col-sm-12 col-xm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Référence d'activation <span class="text-danger">*</span>
                  </label>
                  <Field name="reference" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libelle" />
                  <ErrorMessage name="reference" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <label class="d-block fw-semibold mb-10">
                  Motif
                </label>
                <Field name="motif" as="textarea" placeholder="Entrer l'observation"
                  class="form-control shadow-none rounded-0 text-black" />
                <ErrorMessage name="motif" class="text-danger" />
              </div>
              <button class="btn btn-primary" type="submit" v-show="!auclic" :disabled="auclic">
                Enregistrer
              </button>
              <button class="btn btn-primary" type="button" v-show="auclic" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span>Patientez...</span>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { error, hideModal, showModal, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  name: "EditEtatContratModal",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: 0
    },
  },

  setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {

    const loading = ref<boolean>(false);
    const contratSchema = Yup.object().shape({
      dateMiseEnService: Yup.date().notRequired(),
      contrat: Yup.number().required('Le contrat est obligatoire'),
      reference: Yup.string().required('La référence est obligatoire'),
      motif: Yup.string().notRequired(),
    });
    const addContratModalRef = ref<null | HTMLElement>(null);

    const isupdate = ref(false);
    const contrat = ref<number | null>(null);
    const router = useRouter();
    const auclic = ref(false);
    watch(() => props.id, (newValue) => {
      if (newValue != null && newValue != 0) {
        contrat.value = newValue;
        isupdate.value = true;
        console.log("contrat", contrat.value);
      }
    });

    const modifContratEtat = async (values: { contrat: number; reference: string; motif?: string }, { resetForm }: { resetForm: () => void }) => {
      console.log("values ===>", values);
      auclic.value = true;
      const url = `etat/contrat/${values.contrat}`;
      console.log(values, "valeur");
      loading.value = false;
      await axios.put(url, values).then(({ data }) => {
        if (data.code == 200) {
          success(data.message);
          resetForm();
          hideModal(addContratModalRef.value);
          isupdate.value = false;
          auclic.value = false;
          loading.value = false;
          emit("get-all-contrat");
          router.push('/liste-contrats');
        }
      }).catch(({ response }) => {
        auclic.value = false;
        loading.value = false;
        console.log("error", response);
        error(response.data.message);
      });
    };

    function showModalEdite(model: any) {
      showModal(model);
    }

    return {
      auclic,
      showModalEdite,
      contratSchema,
      modifContratEtat,
      contrat,
      addContratModalRef,
    };
  },
};
</script>
